import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {handleImageUrl, slugify} from "../../helpers";
import {LangContext} from "../../App";

const PackageListItem = ({tour,path}) => {
    const lang = useContext(LangContext)
    const slug = slugify(tour?.title || '')
    return (
        <Link to={`/${lang}/${path}/${tour.id}/${slug}`} className='package-list-item'>
            <img src={handleImageUrl(tour.thumbnail)} alt="asd" />
            <div className="desc">
                <h3>{tour.title}</h3>
                <p>{tour.description}</p>
            </div>
            <div className="price">
                <span>{tour.price}</span>
            </div>
        </Link>
    );
};

export default PackageListItem;